<div class="container">
  <div class="message">
    <p>Coming Soon!</p>
  </div>
</div>
